import { Component } from 'react'
import { Button } from 'reactstrap'
import styles from './Header.module.css'
import person from '../images/person.svg'
import gear from '../images/gear.svg'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Grow } from '@material-ui/core'
import Command from '../helpers/Command'
import infoIcon from '../images/info.svg'

//import {Collapse} from '@material-ui/transitions/Collapse';
//import {Grow} from '@material-ui/transitions/Grow';
const BACKUP_LOGO =
  'data:image/png;base64,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'

class Header extends Component {
  state = { collapsed: true }

  logOut = () => {
    let bbsparql = this.props.bbsparqlendpoint
    if (bbsparql != null) {
      Command.sendCommand(this, 'logout', null, function () {
        window.location.reload(false)
      })
    } else {
      console.log('logout from config mongo/nodejs platform')
      // localStorage.removeItem('kvk-vb-token');
    }

    //window.location.reload(false);
  }

  login = () => {
    this.props.history.push('/login', this.props.location.pathname)
  }

  onClickManageUsers = () => {
    this.props.history.push('/users', this.props.location.pathname)
  }

  mouseOver = (e) => {
    console.log('in')
    // this.setState({collapsed:false});
  }
  mouseOut = (e) => {
    console.log('out')
    // this.setState({collapsed:true});
  }

  render() {
    const { loading, isAuthenticated, role } = this.props.me
    const collapsed = this.state.collapsed

    return (
      <Grow direction="up" appear={true} timeout={1000} in={collapsed}>
        <div className={styles.wrapper}>
          <div
            className={styles.main}
            style={{ maxWidth: this.props.pageWidth }}
          >
            <img
              src={this.props.logoURL || BACKUP_LOGO}
              alt="logo"
              style={{ maxHeight: '40px', marginRight: '6px' }}
            />

            <div className={styles.centerPart}>
              <span
                className={styles.title}
                style={{ float: this.props.alignTitle || 'right' }}
              >
                {this.props.title || 'Connected Apps'}
                {this.props.onInfoClick && (
                  <img
                    src={infoIcon}
                    alt="box"
                    className={styles.infoIcon}
                    onClick={() => this.props.onInfoClick()}
                  />
                )}
                {this.props.onSettingsClick && (
                  <img
                    onClick={this.props.onSettingsClick}
                    src={gear}
                    alt="gear"
                    style={{ paddingLeft: '12px', cursor: 'pointer' }}
                  />
                )}
              </span>
              <span>{this.props.subtitle}</span>
            </div>

            {!loading && isAuthenticated && (
              <div className={styles.auth}>
                <img src={person} alt="person" />
                <div className={styles.nameContainer}>
                  <div style={{ lineHeight: '1.1em' }}>
                    {this.props.me.name}
                  </div>
                  {(role === 'admin' || role === 'superadmin') && (
                    <Button
                      color="link"
                      style={{ padding: '0', fontSize: '0.8em' }}
                      onClick={this.onClickManageUsers}
                    >
                      Gebruikers beheren
                    </Button>
                  )}
                </div>
                <Button color="link" onClick={this.logOut}>
                  Log out
                </Button>
              </div>
            )}
            {!loading && !isAuthenticated && !this.props.noLoginButton && (
              <div className={styles.auth}>
                <Button color="primary" onClick={this.login}>
                  Login
                </Button>
              </div>
            )}
          </div>
        </div>
      </Grow>
    )
  }
}

const mapStateToProps = (state) => ({
  me: state.me,
})

Header = withRouter(Header)

export default connect(mapStateToProps)(Header)
